module.exports = __webpack_public_path__ + "media/fonts/SFProText-Medium-f3ef86c823d991dfd7df204fcae3d7a5.woff";